import requests from "./httpService";

const RateChartServices = {

  // Get All Rate Charts
  getAllRateCharts: async (params = {}) => {
    return requests.get("/rateChart", { params });
  },

  // Create New Rate
  createRateChart: async (body) => {
    return requests.post("/rateChart", body);
  },

    approvedRate: async (body) => {
    return requests.post("/rateChart/approved-rate", body);
  },

  // Pending Rate Approvals
  getPendingRateCharts: async (params = {}) => {
    return requests.get("rateChart", { params });
  },

  // Approve Rate
  approveRateChart: async (id, body) => {
    return requests.patch(`/rateChart/${id}/approve`, body);
  },

  // Reject Rate
  rejectRateChart: async (id, body) => {
    return requests.patch(`/rateChart/${id}/reject`, body);
  },

  // Rate Chart History
  getRateChartHistory: async (id) => {
    return requests.get(`/rateChart/history/${id}`);
  }

};

export default RateChartServices;